export const enviornment = {
    production:false,
    baseUrl:'https://dev.admedonline.co.za/api/',

}
